import React, { useEffect, useState } from 'react';
import { CloseButton, Container, Navbar, ProgressBar } from 'react-bootstrap';
import PaymentSteps from './PaymentSteps';
import { useLocation } from 'react-router-dom';
import { routePaths } from 'routes/routePaths';

function WiseNavbar() {
  const [progressCount, setProgressCount] = useState(0);

  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === routePaths.HOME) {
      setProgressCount(0);
    }
    if (
      pathname === routePaths.CONTACT_EXISTING ||
      pathname === routePaths.CONTACT_TYPES ||
      pathname === routePaths.CONTACT_MYSELF ||
      pathname === routePaths.CONTACT_SOMEONE_ELSE ||
      pathname === routePaths.CONTACT_BUSINESS_CHARITY
    ) {
      setProgressCount(33.33);
    }
    if (pathname === routePaths.REVIEW_URL) {
      setProgressCount(66.66);
    }
    if (pathname === routePaths.PAY_URL) {
      setProgressCount(100);
    }
  }, [pathname]);
  return (
    <div>
      <Navbar className="px-lg-3 py-lg-4">
        <Container>
          <Navbar.Brand href={routePaths.HOME}>Wise</Navbar.Brand>

          <PaymentSteps
            progressCount={progressCount}
            setProgressCount={setProgressCount}
            className="d-none d-lg-block"
          />

          <CloseButton className="border-primary rounded-circle p-2 fs--1" />
        </Container>
      </Navbar>
      <Container className="d-lg-none">
        <ProgressBar
          now={progressCount}
          style={{ height: '2px' }}
          className="mb-3 overflow-visible custom-progress-bar"
        />
      </Container>
    </div>
  );
}

export default WiseNavbar;
